// client/src/services/alarmService.js
// Thin REST client for /api/alarms/*.

import { API_URL } from '../config.js';

function auth() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

async function j(res) {
  const data = await res.json();
  if (!data.success) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
}

const alarmService = {
  // ----- Config -----
  async listConfigs(plantId) {
    const r = await fetch(`${API_URL}/alarms/config?plantId=${encodeURIComponent(plantId)}`, { headers: auth() });
    return (await j(r)).configs;
  },
  async createConfig(body) {
    const r = await fetch(`${API_URL}/alarms/config`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).config;
  },
  async updateConfig(id, body) {
    const r = await fetch(`${API_URL}/alarms/config/${id}`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).config;
  },
  async deleteConfig(id) {
    const r = await fetch(`${API_URL}/alarms/config/${id}`, { method: 'DELETE', headers: auth() });
    return j(r);
  },

  // ----- Active / history -----
  async listActive(plantId) {
    const r = await fetch(`${API_URL}/alarms/active?plantId=${encodeURIComponent(plantId)}`, { headers: auth() });
    return (await j(r)).events;
  },
  async listHistory(plantId, { from, to, limit = 200 } = {}) {
    const qs = new URLSearchParams({ plantId, limit });
    if (from) qs.set('from', from);
    if (to)   qs.set('to', to);
    const r = await fetch(`${API_URL}/alarms/history?${qs}`, { headers: auth() });
    return (await j(r)).events;
  },

  // ----- Ack / shelve -----
  async ack(eventId) {
    const r = await fetch(`${API_URL}/alarms/events/${eventId}/ack`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', ...auth() }
    });
    return j(r);
  },
  async shelve(configId, hours = 4) {
    const r = await fetch(`${API_URL}/alarms/config/${configId}/shelve`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify({ hours })
    });
    return j(r);
  },
  async unshelve(configId) {
    const r = await fetch(`${API_URL}/alarms/config/${configId}/unshelve`, {
      method: 'POST', headers: auth()
    });
    return j(r);
  },

  // ----- Stats / nuisance -----
  async stats(plantId) {
    const r = await fetch(`${API_URL}/alarms/stats?plantId=${encodeURIComponent(plantId)}`, { headers: auth() });
    return (await j(r)).stats;
  },
  async nuisance(plantId) {
    const r = await fetch(`${API_URL}/alarms/nuisance?plantId=${encodeURIComponent(plantId)}`, { headers: auth() });
    return (await j(r)).candidates;
  },

  // ----- Notification groups -----
  async listGroups(plantId) {
    const r = await fetch(`${API_URL}/alarms/notif-groups?plantId=${encodeURIComponent(plantId)}`, { headers: auth() });
    return (await j(r)).groups;
  },
  async createGroup(body) {
    const r = await fetch(`${API_URL}/alarms/notif-groups`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).group;
  },
  async updateGroup(id, body) {
    const r = await fetch(`${API_URL}/alarms/notif-groups/${id}`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).group;
  },
  async deleteGroup(id) {
    const r = await fetch(`${API_URL}/alarms/notif-groups/${id}`, { method: 'DELETE', headers: auth() });
    return j(r);
  }
};

export default alarmService;
